module.exports = __webpack_public_path__ + "img/1-2301091551023T.97a58fce.jpg";